module.exports = __webpack_public_path__ + "img/icon_all.8359ef0d.svg";